'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Up = require('./Up');

var _Up2 = _interopRequireDefault(_Up);

var _Down = require('./Down');

var _Down2 = _interopRequireDefault(_Down);

var _SortArrows = require('./SortArrows');

var _SortArrows2 = _interopRequireDefault(_SortArrows);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Up: _Up2.default, Down: _Down2.default, SortArrows: _SortArrows2.default };


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Sort/index.js
// module id = 322
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15